"use strict";
exports.__esModule = true;
var validateASCII = function (value, name) {
    if (!/^[\x00-\x7F]*$/.test(value)) {
        return name + " \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E ASCII \u0441\u0438\u043C\u0432\u043E\u043B\u044B";
    }
    return '';
};
exports["default"] = validateASCII;
